import { Column, defaultColDef } from '@qrios/frontend-library';

import { predefinedColumns } from '../../../../../common/table/columns/predefinedColumns';
import { operationTypeFormatter } from '../../../../../common/table/utils/operationTypeFormatters';

export const columns: Column[] = [
  predefinedColumns.date({ sortable: true }),
  predefinedColumns.status({ sortable: true }),
  predefinedColumns.cost({ sortable: true, withInfoIcon: true }),
  {
    ...defaultColDef,
    flex: 2,
    field: 'operationType',
    headerName: 'Operation type',
    valueFormatter: operationTypeFormatter,
    sortable: true
  }
];
